import {jsonMember, jsonObject} from "typedjson";
import {DxListItemDataProvider} from "../../dx-lists/domain/list/dx-list-item-data-provider";

/**
 *  Узел дерева отчетов
 * */


@jsonObject
export class PitReportsTreeNode implements DxListItemDataProvider{

  @jsonMember({name: "id", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _id: number;

  @jsonMember({name: "parentId", constructor: Number, emitDefaultValue: false, preserveNull: true, isRequired: true })
  private _parentId: number = null;

  @jsonMember({name: "ord", constructor: Number, emitDefaultValue: false, isRequired: false })
  private _ord: number;

  @jsonMember({name: "ident", constructor: String, emitDefaultValue: false, isRequired: false })
  private _ident: string;

  @jsonMember({name: "title", constructor: String, emitDefaultValue: false, isRequired: false })
  private _title: string;

  @jsonMember({name: "type", constructor: String, emitDefaultValue: false, isRequired: false})
  private _type: string;

  @jsonMember({name: "description", constructor: String, emitDefaultValue: false, isRequired: false })
  private _description: string;

  @jsonMember({name: "link", constructor: String, emitDefaultValue: false, isRequired: false })
  private _link: string;

  public getItemId(): number {
    return this._id;
  }

  public getParentItemId(): number {
    return this._parentId;
  }

  setParentItemId(value: number): void {
    this._parentId = value;
  }

  public getItemType(): string {
    return this._type;
  }

  public setItemType(value: string): void {
    this._type = value;
  }

  public getItemOrd(): number {
    return this._ord;
  }

  public getItemTitle(): string {
    return this._title;
  }

  public getItemIdent(): string {
    return this._ident;
  }

  public getItemIcon(): string {
    return "";
  }

  public getItemDescription(): string {
    return this._description;
  }

  public getItemSearchString(): string {
    return "";
  }

  get id(): number {
    return this._id;
  }

  set id(value: number) {
    this._id = value;
  }

  get parentId(): number {
    return this._parentId;
  }

  set parentId(value: number) {
    this._parentId = value;
  }

  get ord(): number {
    return this._ord;
  }

  set ord(value: number) {
    this._ord = value;
  }

  get ident(): string {
    return this._ident;
  }

  set ident(value: string) {
    this._ident = value;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }

  get type(): string {
    return this._type;
  }

  set type(value: string) {
    this._type = value;
  }

  get description(): string {
    return this._description;
  }

  set description(value: string) {
    this._description = value;
  }

  get link(): string {
    return this._link;
  }

  set link(value: string) {
    this._link = value;
  }
}
